import { computed } from 'vue'
import { useProjectsStore } from '@/modules/projects/stores/useProjectsStore'
import { useAuthStore } from '@/modules/auth/stores/useAuthStore'

/**
 * Composable for checking permissions
 * Centralizes permission logic to avoid duplication across views
 */
export function usePermissions() {
  const projectsStore = useProjectsStore()
  const authStore = useAuthStore()

  /**
   * Check if user has a specific permission for the current project
   */
  const can = (permission: string) => {
    if (!projectsStore.currentProject) return false

    const projectPermissions = projectsStore.currentProjectPermissions || []
    return authStore.hasPermission(permission, projectPermissions)
  }

  /**
   * Create a computed property for permission check
   */
  const canManage = (permission: string) => {
    return computed(() => can(permission))
  }

  return {
    can,
    canManage
  }
}
